import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import Logo1 from '../Medias/mockup/thac.png'
import Logo2 from '../Medias/mockup/legalindustry.png'

function SectionLogo({ contents = [] }) {
  return (
    <section id="logos" className="pt-5 pb-0">
      <Container className='pt-5 pb-0'>
        <>
          <Row className='text-center'>
            <Col className='mx-auto pb-3'>
              <img src={Logo1} style={{width: '100%', maxWidth: '200px'}} />
            </Col>
            <Col className='mx-auto pb-3'>
              <img src={Logo2} style={{width: '100%', maxWidth: '200px'}} />
            </Col>
          </Row>
        </>
      </Container>
    </section >
  )
}

export default SectionLogo